import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

function Gigs({ userProfile }) {
  const navigate = useNavigate();
  const goBack = () => navigate('/');

  return (
    <div className={`dashboard ${userProfile["theme"]}`}>
      <div className="profile-container">
        <div className="dashboard-box">
          <button className="short" onClick={goBack}>back</button>
          <h2>Gigs</h2>
          <p>Page stub. Content coming soon.</p>
        </div>
      </div>
    </div>
  );
}

export default Gigs;
